import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-root-redirect',
  template: ''
})
export class RootRedirectComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.router.navigate(['/dashboard'], {
      queryParams: this.route.snapshot.queryParams,
      replaceUrl: true
    });
  }
}